import React from "react";
import "./Footer.css";
import { Fade } from "react-reveal";
import { useLanguage } from "../../context/LanguageContext";
import { getTranslation } from "../../translations/translations";
/* eslint-disable jsx-a11y/accessible-emoji */

export default function Footer(props) {
  const currentYear = new Date().getFullYear();
  const { language } = useLanguage();

  const footerLinks = [
    { name: getTranslation(language, "home"), href: "#greeting" },
    { name: getTranslation(language, "about"), href: "#about" },
    { name: getTranslation(language, "worship_services"), href: "#services" },
    { name: getTranslation(language, "contact_us"), href: "#contact" },
    { name: getTranslation(language, "donate"), href: "#donate" },
  ];

  const socialLinks = [
    {
      name: getTranslation(language, "email_label"),
      href: "mailto:tsirhatsion.nz@gmail.com",
      icon: "📧",
    },
    {
      name: getTranslation(language, "phone_label"),
      href: "tel:+64-204-142-9913",
      icon: "📱",
    },
  ];

  return (
    <footer className="footer-div">
      <Fade>
        <div className="footer-content">
          {/* Quick Links Section */}
          <div className="footer-section">
            <h4 style={{ color: "#ffffff" }}>
              {getTranslation(language, "quick_links")}
            </h4>
            <ul className="footer-links">
              {footerLinks.map((link, index) => (
                <li key={index}>
                  <a href={link.href} style={{ color: "#e0e0e0" }}>
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Section */}
          <div className="footer-section">
            <h4 style={{ color: "#ffffff" }}>
              {getTranslation(language, "contact_us")}
            </h4>
            <div className="contact-links">
              {socialLinks.map((link, index) => (
                <a
                  key={index}
                  href={link.href}
                  className="contact-link"
                  style={{ color: "#e0e0e0" }}
                  title={link.name}
                >
                  <span>{link.icon}</span>
                  <span>{link.name}</span>
                </a>
              ))}
            </div>
          </div>

          {/* About Section */}
          <div className="footer-section">
            <h4 style={{ color: "#ffffff" }}>
              {getTranslation(language, "footer_about_us")}
            </h4>
            <p style={{ color: "#b0b0b0" }} className="footer-about-text">
              {getTranslation(language, "church_name")}
            </p>
          </div>
        </div>

        {/* Copyright Section */}
        <div className="footer-bottom">
          <p className="footer-text" style={{ color: "#ffffff" }}>
            {getTranslation(language, "footer_all_rights").replace(
              "{year}",
              currentYear
            )}
          </p>
          <p className="footer-subtext" style={{ color: "#a0a0a0" }}>
            {getTranslation(language, "footer_made_with_love")}
          </p>
        </div>
      </Fade>
    </footer>
  );
}
